import validationRules from "../validationRules";
validationRules.register("min", function (record, fieldMetadataMap, fieldName, t) {
    var args = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args[_i - 4] = arguments[_i];
    }
    var length = args[0] || undefined;
    var value = record[fieldName] || "";
    var fieldLabel = fieldName;
    var fieldMetadata = fieldMetadataMap.get(fieldName);
    if (!length || value.length >= length) {
        return true;
    }
    if (["varchar", "name"].includes(fieldMetadata.type)) {
        return "min length should be ".concat(length, ".");
    }
    else if (["int"].includes(fieldMetadata.type)) {
        if (length > value) {
            return "min should be ".concat(length, ".");
        }
    }
    return true;
});
